/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ScheduleSiteChangeRequestDto } from '../scheduleSiteChangeRequestDto.schema';

export const CreateSscrSiteAssignment = zod.object({
  "payload": zod.lazy(() => ScheduleSiteChangeRequestDto).optional()
});

export type CreateSscrSiteAssignment = zod.input<typeof CreateSscrSiteAssignment>;
export type CreateSscrSiteAssignmentOutput = zod.output<typeof CreateSscrSiteAssignment>;
